const pedido = (DataBase, Datatype) => {
	const Pedido = DataBase.new(
		{
			nr_pedido: Datatype.NUMBER,
			id_forma_pagamento: Datatype.STRING,
			produtos: Datatype.ARRAY,
			v_total: Datatype.NUMBER,
			v_desconto: Datatype.NUMBER,
			t_desconto: Datatype.NUMBER,
			obs: Datatype.STRING,
			data_pedido: Datatype.TIMESTAMP,
		},
		{
			tracked: true,
			dateLogs: true,
			softDelete: true,
			collection: "pedido",
			model: "Pedido",
			parent: "Cliente",
		}
	);

	Pedido.relate = (models) => [
		{
			model: models.FormaPagamento,
			fk: "id_forma_pagamento",
			name: "forma_pagamento",
		},
	];

	return Pedido;
};

export default pedido;
